var React = require('react');

function Unlocked (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.5 25.8A1.54 1.54 0 0 1 0 24.3v-9.5c0-3.9 1.5-7.7 4.3-10.5S10.8 0 14.8 0c3.9 0 7.6 1.5 10.4 4.3s4.4 6.5 4.4 10.5v9.5a1.54 1.54 0 0 1-1.5 1.5 1.54 1.54 0 0 1-1.5-1.5v-9.5c0-3.1-1.2-6.1-3.5-8.3C20.9 4.2 17.9 3 14.8 3c-3.2 0-6.1 1.2-8.4 3.5C4.2 8.7 3 11.7 3 14.8v9.5a1.54 1.54 0 0 1-1.5 1.5z","key":0}),React.createElement("path",{"d":"M54.7 60H20.5a5.34 5.34 0 0 1-5.3-5.3V28.1a5.34 5.34 0 0 1 5.3-5.3h34.2a5.34 5.34 0 0 1 5.3 5.3v26.6a5.34 5.34 0 0 1-5.3 5.3zM20.5 25.8a2.26 2.26 0 0 0-2.3 2.3v26.6a2.26 2.26 0 0 0 2.3 2.3h34.2a2.26 2.26 0 0 0 2.3-2.3V28.1a2.26 2.26 0 0 0-2.3-2.3H20.5zm17.1 20.9a1.54 1.54 0 0 1-1.5-1.5v-7.6a1.54 1.54 0 0 1 1.5-1.5 1.54 1.54 0 0 1 1.5 1.5v7.6a1.54 1.54 0 0 1-1.5 1.5z","key":1})]);
}

Unlocked.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = Unlocked;

Unlocked.default = Unlocked;
